module.exports = __webpack_public_path__ + "assets/img/ruleTopBgimg.efeb99cd.jpg";